import React from 'react';
import cn from 'classnames';
import SearchParameterStyles from './SearchParameterStyles';

// TODO rafactor component - скопирован из поиска машин
const SearchParameter = (props) => {
  return (
    <SearchParameterStyles
      inline={props.inline}
      offsetBottom={props.offsetBottom}
      captionNoOffset={props.captionNoOffset}
      extra={props.extra}
      className={props.extra ? 'extra' : ''}
    >
      {(!!props?.caption || !!props?.captionNode) && (
        <span
          className={cn({
            caption: true,
            bold: props.bold,
            required: props.required,
            strong: props.strong,
          })}
        >
          {props.captionNode || props.caption}
        </span>
      )}
      <div
        className={[
          'search-field',
          props.invalid ? 'invalid' : '',
          props.double ? 'double' : '',
          props.select ? 'select' : '',
          props.small ? 'small' : '',
          props.sizes ? 'sizes' : '',
          props.volumeAndWeight ? 'volume-and-weight' : '',
          props.geosuggest ? 'geo-suggest' : '',
          props.dateOfAnnouncement ? 'date-of-announcement' : '',
          props.typeOfTransport ? 'type-of-transport' : '',
          props.rentPrice ? 'rent-price' : '',
          props.brand ? 'brand' : '',
          props.model ? 'model' : '',
          props.className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {props.children}
      </div>
    </SearchParameterStyles>
  );
};

export default SearchParameter;
